// extracted by mini-css-extract-plugin
export default {"l_MoveArrowBtn_main":"MoveArrowBtn_l_MoveArrowBtn_main__fzUpO","diraction":"MoveArrowBtn_diraction__mqvO5","left":"MoveArrowBtn_left__3Emng","right":"MoveArrowBtn_right__p0H6x"};